import http from '@/services/http'
import type { ModuleMeta, Response } from '@/models/api-generated'
import type { ModuleForm, MethodForm } from '@/types/module'
import { ref } from 'vue'
import { newMethodForm, newModuleForm, newModuleMeta } from '@/services/utils'

export const useModule = (metaId: number) => {
	const moduleMeta = ref<ModuleMeta>(newModuleMeta())
	const moduleForm = ref<ModuleForm>(newModuleForm())
	const methodsForm = ref<MethodForm[]>([newMethodForm()])

	;(async () => {
		const { data } = await http.get<Response<ModuleMeta>>(`/api/module/${metaId}`)
		if (data.data) {
			moduleMeta.value = data.data

			moduleForm.value.id = data.data.module.id
			moduleForm.value.description = data.data.module.description
			moduleForm.value.name = data.data.module.name
			moduleForm.value.version = data.data.module.version
			moduleForm.value.type = data.data.module.type
			moduleForm.value.isCustom = data.data.module.isCustom
			moduleForm.value.instance = data.data.instance
			moduleForm.value.responsible = data.data.responsible
			moduleForm.value.active = data.data.active
			moduleForm.value.isApplicable = data.data.isApplicable
			moduleForm.value.assetAssociations = data.data.assetAssociations
			moduleForm.value.urlReferences = data.data.urlReferences
			moduleForm.value.documentReferences = data.data.documentReferences

			if (data.data.securityNeed) moduleForm.value.securityNeed = data.data.securityNeed

			methodsForm.value = data.data.module.methods.map((m) => ({
				id: m.id,
				description: m.description,
				applicable: m.applicable,
				name: m.name,
				type: m.type,
				securityNeed: m.securityNeed,
				confidentiality: m.confidentiality,
				integrity: m.integrity,
				availability: m.availability,
				status: m.status,
				rules: m.rules.map((r) => ({
					id: r.id,
					value: r.value,
					methodId: r.method_id,
					subrules: r.subRules.map((sr) => ({
						id: sr.id,
						value: sr.value,
					})),
				})),
			}))
		}
	})()

	return {
		moduleMeta,
		moduleForm,
		methodsForm,
	}
}
